import type { DataSource } from "../../store/api/dataSourcesApi";

const SECRET_KEYS = new Set([
  "apiKey",
  "api_key",
  "adminApiKey",
  "admin_api_key",
  "secretKey",
  "secret_key",
  "secret",
  "password",
]);

function configString(
  config: Record<string, unknown> | null | undefined,
  ...keys: string[]
): string | undefined {
  if (!config) return undefined;
  for (const key of keys) {
    if (SECRET_KEYS.has(key)) continue;
    const value = config[key];
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return undefined;
}

export function byoIndexName(
  config: Record<string, unknown> | null | undefined,
): string | undefined {
  return configString(config, "indexName", "index_name");
}

export function byoAppId(
  config: Record<string, unknown> | null | undefined,
): string | undefined {
  return configString(
    config,
    "appId",
    "app_id",
    "applicationId",
    "application_id",
  );
}

export function byoProviderLabel(
  ds: Pick<DataSource, "provider">,
  labels: Record<string, string>,
): string | null {
  if (!ds.provider) return null;
  return labels[ds.provider] ?? ds.provider;
}
